import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getFontSizeInRangeLimit } from "../../constants/styles/dimensions";
import { preferencesSelectors } from "../../modules/preferences";
import preprocessorQuery from "../../utils/preprocessorQuery";
import ToolbarGroup from "../toolbar/ToolbarGroup";
import ToolbarTextButton from "../toolbar/ToolbarTextButton";
import ToolbarTextLabel from "../toolbar/ToolbarTextLabel";
import ToolbarView from "../toolbar/ToolbarView";

const isIos = preprocessorQuery.isIos();
const isMobile = preprocessorQuery.isMobile();

const NavigationToolbar = props => {
  // Force back text to always be "Back" on mobile
  const backText = !isMobile && props.backText ? props.backText : "Back";
  return (
    <ToolbarView fontSize={getFontSizeInRangeLimit(props.globalFontSize)}>
      <ToolbarGroup position="leftTop" flex={props.flexLeft}>
        {props.showBack ? (
          <ToolbarTextButton
            text={backText}
            navigateBackStyle={true}
            onClick={props.onBackClick}
            icon={props.showBackArrow ? "leftArrow" : null}
          />
        ) : null}
      </ToolbarGroup>
      <ToolbarGroup position={isIos ? "centerTop" : "center"} flex={props.flexCenter}>
        {props.title ? <ToolbarTextLabel text={props.title} /> : null}
      </ToolbarGroup>
      <ToolbarGroup position="right" flex={props.flexRight}>
        {props.showRightComponent ? props.rightComponent : null}
        {props.showNext ? (
          <ToolbarTextButton
            text={props.nextText ? props.nextText : "Next"}
            navigateBackStyle={true}
            onClick={props.onNextClick}
            disabled={props.nextDisabled}
          />
        ) : null}
      </ToolbarGroup>
    </ToolbarView>
  );
};

NavigationToolbar.propTypes = {
  showBack: PropTypes.bool,
  showBackArrow: PropTypes.bool,
  backText: PropTypes.string,
  onBackClick: PropTypes.func,

  title: PropTypes.string,
  globalFontSize: PropTypes.number.isRequired,

  showNext: PropTypes.bool,
  nextText: PropTypes.string,
  nextDisabled: PropTypes.bool,
  onNextClick: PropTypes.func,
  showRightComponent: PropTypes.bool,
  rightComponent: PropTypes.object,

  flexLeft: PropTypes.number,
  flexCenter: PropTypes.number,
  flexRight: PropTypes.number
};

const mapStateToProps = state => {
  return {
    globalFontSize: preferencesSelectors.getGlobalFontSize(state.present)
  };
};

export default connect(mapStateToProps, null)(NavigationToolbar);
